exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.actions[data-v-74dbfd32] {\n  background: #fff;\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  padding-left: 0.75rem;\n  padding-bottom: 0.1rem;\n}\n.addNoteIcon[data-v-74dbfd32] {\n  line-height: 0.6rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-74dbfd32","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/EventNotes.vue
// module id = 2705
// module chunks = 0